import * as React from 'react'
import { EditActivityForm } from './EditActivityForm/EditActivityForm'
import { useGetActivityOnMount } from './hooks'
import { NormalizedActivity } from './EditActivityForm/typings'
import { useEffect } from 'react'
import Popover, { PopoverOrigin } from '@mui/material/Popover'
import Backdrop from '@mui/material/Backdrop'
import CircularProgress from '@mui/material/CircularProgress'

type Props = {
  activityId: number | undefined
  anchorEl: HTMLElement | null
  anchorOrigin?: PopoverOrigin
  onClose: () => void
  onSave?: (activity: NormalizedActivity) => void
}

export function EditActivityPopover(props: Props) {
  const { activityId, onClose, onSave } = props
  const { anchorOrigin = { vertical: 'top', horizontal: 'left' } } = props
  const { activity, status } = useGetActivityOnMount(activityId)

  const open = !!activityId

  useEffect(() => {
    if (status === 'error') {
      onClose()
    }
  }, [onClose, status])

  return (
    <Backdrop open={open}>
      {activity && (
        <Popover
          id="popover"
          open={open}
          anchorEl={undefined}
          anchorReference={'none'}
          hideBackdrop={false}
          onClose={onClose}
          anchorOrigin={anchorOrigin}
          sx={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
          }}
        >
          {activityId !== null &&
            (status === 'loading' ? (
              <CircularProgress />
            ) : (
              <EditActivityForm
                activity={activity}
                onClose={onClose}
                onSave={onSave}
              />
            ))}
        </Popover>
      )}
    </Backdrop>
  )
}
